import { Box, Center, Flex, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { entityProfileModalColors } from "../entityProfileModal.theme";
import EntityModalButton from "./EntityModalButton";

type Props = {
  children: React.ReactNode;
  entityLabel: string;
  isError: boolean;
  isLoading: boolean;
  onClose: () => void;
  onRetry: () => void;
  /**
   * Inside the AngularJS shell the close control is rendered by the modal
   * template (`react-patient-modal.html` / `react-caregiver-modal.html`) so it
   * can hang off `.modal-content` and pick up the legacy `left: -60px`
   * placement on the overlay. Only standalone hosts such as the workbench,
   * which have no such wrapper, ask the frame to draw its own.
   */
  showCloseButton?: boolean;
};

export default function EntityProfileModalFrame(props: Props) {
  return (
    <Flex direction="column" h="100%" minH="640px" position="relative">
      {props.isLoading && !props.isError ? (
        <Box
          bg="#b7d4ff"
          h="3px"
          left={0}
          overflow="hidden"
          position="absolute"
          right={0}
          top={0}
          zIndex={3}
        >
          <Box
            animation="entity-profile-loading-line 1.2s ease-in-out infinite"
            bg="#5565f6"
            h="100%"
            w="34%"
          />
          <style>{`
            @keyframes entity-profile-loading-line {
              0% { transform: translateX(-110%); }
              50% { transform: translateX(95%); }
              100% { transform: translateX(320%); }
            }
          `}</style>
        </Box>
      ) : null}
      {props.showCloseButton === true ? (
        <EntityModalButton
          aria-label={`Close ${props.entityLabel} modal`}
          className="close"
          kind="white"
          style={{
            background: "none",
            border: "none",
            color: entityProfileModalColors.muted,
            fontSize: 24,
            fontWeight: 300,
            height: 32,
            lineHeight: 1,
            minWidth: 32,
            opacity: 1,
            padding: 0,
            position: "absolute",
            right: 18,
            top: 14,
            zIndex: 2,
          }}
          onClick={props.onClose}
        >
          &times;
        </EntityModalButton>
      ) : null}
      {props.isError ? (
        <Center flex={1}>
          <VStack spacing={3}>
            <Text color={entityProfileModalColors.danger} fontWeight={700}>
              Could not load {props.entityLabel} profile.
            </Text>
            <EntityModalButton kind="white" onClick={props.onRetry}>
              Retry
            </EntityModalButton>
          </VStack>
        </Center>
      ) : (
        props.children
      )}
    </Flex>
  );
}
